module.exports = {"resourceQuery":"?resourcequery","query":"?query1","prev":"module.exports = {\"resourceQuery\":\"?resourcequery\",\"query\":\"?query2\",\"prev\":\"module.exports = \\\"a\\\";\"}"}


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/loaders/queryloader.js?query1!./loaders/query/loaders/queryloader.js?query2!./loaders/query/a.js?resourcequery
 ** module id = 4
 ** module chunks = 0
 **/